<template>
  <main role="main">
    <section class="section section-bonus">
      <div class="container">
        <div class="hero">
          <picture>
            <source
              srcset="~@/assets/i/img/bonus-hero-small.jpg"
              media="(max-width: 767px)"
            />
            <img
              src="~@/assets/i/img/bonus-hero.jpg"
              width="100%"
              height="100%"
              alt=""
            />
          </picture>
        </div>

        <div class="bonus-form">
          <picture>
            <source
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              srcset="~@/assets/img/bonus/bonus_light_ru.svg"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              srcset="~@/assets/img/bonus/bonus_light_en.svg"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              srcset="~@/assets/img/bonus/bonus_dark_ru.svg"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              srcset="~@/assets/img/bonus/bonus_dark_en.svg"
              media="(max-width: 767px)"
            />

            <img
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              src="~@/assets/img/bonus/bonus_light_ru.png"
              alt=""
              id="bonus-logo"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              src="~@/assets/img/bonus/bonus_light_en.png"
              alt=""
              id="bonus-logo"
            />
            <img
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              src="~@/assets/img/bonus/bonus_dark_ru.png"
              alt=""
              id="bonus-logo"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              src="~@/assets/img/bonus/bonus_dark_en.png"
              alt=""
              id="bonus-logo"
            />
          </picture>

          <h1>
            {{ $t("bonus.registration_form1") }} <br />
            {{ $t("bonus.registration_form2") }}
          </h1>

          <form
            method="post"
            enctype="multipart/form-data"
            @submit.prevent="checkForm"
          >
            <p class="notice">{{ $t("bonus.required") }}</p>

            <div class="row">
              <div class="field">
                <label for="lastName">{{ $t("bonus.last_name") }}</label>
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  placeholder="PETROV"
                  v-model="form.lastName"
                  oninput="this.value = this.value.replace(/[^a-zA-Z]/, '').toUpperCase()"
                />
              </div>
              <div class="field">
                <label for="name">{{ $t("bonus.first_name") }}</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="IVAN"
                  v-model="form.name"
                  oninput="this.value = this.value.replace(/[^a-zA-Z]/, '').toUpperCase()"
                />
              </div>
            </div>
            <div class="row three-col">
              <div class="field">
                <label for="birthdate">{{ $t("bonus.date_of_birth") }}</label>
                <input
                  type="text"
                  name="birthdate"
                  id="birthdate"
                  placeholder="DD.MM.YYYY"
                  v-model="form.birthdate"
                  oninput="this.value = this.value.replace(/[^0-9]/, '')"
                  v-date
                />
              </div>
              <div class="field">
                <label for="phone">{{ $t("bonus.phone") }}</label>
                <input
                  type="phone"
                  name="phone"
                  id="phone"
                  placeholder="74951234567"
                  v-model="form.phone"
                  oninput="this.value = this.value.replace(/[^0-9]/, '')"
                  v-phone
                />
              </div>
              <div class="field">
                <label for="email">E-mail</label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="example@domain.ru"
                  v-model="form.email"
                />
              </div>
            </div>
            <div class="row">
              <div class="field checkbox">
                <div class="input-checkbox">
                  <input
                    required
                    name="value"
                    value="1"
                    type="checkbox"
                    id="participationAgreement"
                    v-model="form.participationAgreement"
                  />
                  <span class="checkmark">
                    <svg
                      width="17"
                      height="12"
                      viewBox="0 0 17 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.40625 11.75C6.71875 12.0625 7.25 12.0625 7.5625 11.75L16.75 2.5625C17.0625 2.25 17.0625 1.71875 16.75 1.40625L15.625 0.28125C15.3125 -0.03125 14.8125 -0.03125 14.5 0.28125L7 7.78125L3.46875 4.28125C3.15625 3.96875 2.65625 3.96875 2.34375 4.28125L1.21875 5.40625C0.90625 5.71875 0.90625 6.25 1.21875 6.5625L6.40625 11.75Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </div>
                <label for="participationAgreement"
                  >{{ $t("bonus.agree") }}
                  <a href="" @click.prevent="openBonusParticipationAgreement()"
                    >{{ $t("bonus.condition") }}<br />
                    {{ $t("bonus.bonus") }}</a
                  ></label
                >
              </div>
              <div class="field checkbox">
                <div class="input-checkbox">
                  <input
                    required
                    name="value"
                    value="1"
                    type="checkbox"
                    id="treatmentAgreement"
                    v-model="form.treatmentAgreement"
                  />
                  <span class="checkmark">
                    <svg
                      width="17"
                      height="12"
                      viewBox="0 0 17 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.40625 11.75C6.71875 12.0625 7.25 12.0625 7.5625 11.75L16.75 2.5625C17.0625 2.25 17.0625 1.71875 16.75 1.40625L15.625 0.28125C15.3125 -0.03125 14.8125 -0.03125 14.5 0.28125L7 7.78125L3.46875 4.28125C3.15625 3.96875 2.65625 3.96875 2.34375 4.28125L1.21875 5.40625C0.90625 5.71875 0.90625 6.25 1.21875 6.5625L6.40625 11.75Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </div>
                <label for="treatmentAgreement"
                  >{{ $t("bonus.give") }}
                  <a href="" @click.prevent="openBonusTreatmentAgreement()"
                    >{{ $t("bonus.processing") }}<br />
                    {{ $t("bonus.credintails") }}</a
                  ></label
                >
              </div>
            </div>
            <div class="row">
              <div class="buttons">
                <button
                  type="submit"
                  class="submit"
                  :disabled="
                    !(form.treatmentAgreement && form.participationAgreement)
                  "
                  :class="{
                    hiddenbtn: !(
                      form.treatmentAgreement && form.participationAgreement
                    ),
                  }"
                  name="done"
                >
                  {{ $t("bonus.sign_up") }}
                </button>
              </div>
              <div class="errors">
                <ul>
                  <li v-for="(error, index) in errors" :key="index">
                    <p>
                      <svg
                        width="24"
                        height="23"
                        viewBox="0 0 24 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 22.75C8.04688 22.75 4.4375 20.6875 2.46094 17.25C0.484375 13.8555 0.484375 9.6875 2.46094 6.25C4.4375 2.85547 8.04688 0.75 12 0.75C15.9102 0.75 19.5195 2.85547 21.4961 6.25C23.4727 9.6875 23.4727 13.8555 21.4961 17.25C19.5195 20.6875 15.9102 22.75 12 22.75ZM12 6.25C11.3984 6.25 10.9688 6.72266 10.9688 7.28125V12.0938C10.9688 12.6953 11.3984 13.125 12 13.125C12.5586 13.125 13.0312 12.6953 13.0312 12.0938V7.28125C13.0312 6.72266 12.5586 6.25 12 6.25ZM10.625 15.875C10.625 16.6484 11.2266 17.25 12 17.25C12.7305 17.25 13.375 16.6484 13.375 15.875C13.375 15.1445 12.7305 14.5 12 14.5C11.2266 14.5 10.625 15.1445 10.625 15.875Z"
                          fill="#DC2F33"
                        />
                      </svg>
                      <span>{{ error }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <BonusSuccess v-show="isBonusSuccess" />
    <BonusFail v-show="isBonusFail" />
  </main>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import BonusSuccess from "../../components/popup/bonus/BonusSuccess";
import BonusFail from "../../components/popup/bonus/BonusFail";

export default {
  name: "Bonus",
  components: {
    BonusFail,
    BonusSuccess,
  },
  computed: {
    ...mapState("bonus", {
      isBonusSuccess: (state) => state.isBonusSuccess,
      isBonusFail: (state) => state.isBonusFail,
    }),
    ...mapState("settings", {
      theme: (state) => state.theme,
      domain: (state) => state.index.system.domain.dataPath,
    }),
    ...mapState("partners", {
      partners: (state) => {
        return state.partners;
      },
    }),
  },

  data: () => {
    return {
      errors: [],
      form: {
        lastName: null,
        name: null,
        birthdate: null,
        phone: "",
        email: null,
        participationAgreement: false,
        treatmentAgreement: false,
      },
    };
  },
  methods: {
    ...mapActions("bonus", {
      bonusRegister: "bonusRegister",
    }),
    ...mapMutations("bonus", {
      updateEntity: "SET_ENTITY",
    }),
    openBonusTreatmentAgreement() {
      this.pushRouteBlank("ceo_bonus_personal_data");
    },
    openBonusParticipationAgreement() {
      this.pushRouteBlank("ceo_bonus_terms_conditions");
    },
    // openBonusSuccess() {
    //   this.updateEntity(["isBonusSuccess", true]);
    // },
    pushRouteBlank(sName) {
      let href = this.partners[this.$i18n.locale].filter(
        (item) => item.tag === `${sName}_${this.theme}`
      )[0].url;
      window.open(href, "_self");
    },
    checkForm() {
      this.errors = [];

      if (!this.form.lastName) {
        this.errors.push(this.$t("bonus.last_name_error"));
        document.getElementById("lastName").parentNode.classList.add("invalid");
      } else if (!this.validText(this.form.lastName)) {
        this.errors.push(this.$t("bonus.last_name_err"));
        document.getElementById("lastName").parentNode.classList.add("invalid");
      } else {
        document
          .getElementById("lastName")
          .parentNode.classList.remove("invalid");
      }

      if (!this.form.name) {
        this.errors.push(this.$t("bonus.first_name_error"));
        document.getElementById("name").parentNode.classList.add("invalid");
      } else if (!this.validText(this.form.name)) {
        this.errors.push(this.$t("bonus.first_name_err"));
        document.getElementById("name").parentNode.classList.add("invalid");
      } else {
        document.getElementById("name").parentNode.classList.remove("invalid");
      }

      if (!this.form.birthdate) {
        this.errors.push(this.$t("bonus.data_error"));
        document
          .getElementById("birthdate")
          .parentNode.classList.add("invalid");
      } else if (!this.validDate(this.form.birthdate)) {
        document
          .getElementById("birthdate")
          .parentNode.classList.add("invalid");
        this.errors.push(this.$t("bonus.data_err"));
      } else {
        document
          .getElementById("birthdate")
          .parentNode.classList.remove("invalid");
      }

      if (!this.form.phone) {
        this.errors.push(this.$t("bonus.phone_error"));
        document.getElementById("phone").parentNode.classList.add("invalid");
      } else if (
        !this.validPhone(this.form.phone) ||
        this.form.phone.length < 11
      ) {
        this.errors.push(this.$t("bonus.phone_err"));
        document.getElementById("phone").parentNode.classList.add("invalid");
      } else {
        document.getElementById("phone").parentNode.classList.remove("invalid");
      }

      if (!this.form.email) {
        this.errors.push(this.$t("bonus.mail_error"));
        document.getElementById("email").parentNode.classList.add("invalid");
      } else if (!this.validEmail(this.form.email)) {
        this.errors.push(this.$t("bonus.mail_err"));
        document.getElementById("email").parentNode.classList.add("invalid");
      } else {
        document.getElementById("email").parentNode.classList.remove("invalid");
      }
      if (!this.errors.length) {
        this.bonusRegister(this.form);
      }
    },
    validEmail(email) {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phoneNumber) {
      let re = /^(0|[1-9]\d*)$/;
      return re.test(phoneNumber);
    },
    validDate(date) {
      let re =
        /^(?:(?:31(\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
      return re.test(date);
    },
    validText(text) {
      let re = /^[a-zA-Z]+$/;
      return re.test(text);
    },
  },
};
</script>
<style scoped>
/* .errors ul { */
/* margin-left: 0; */
/* padding-left: 0; */
/* } */
.errors ul li {
  list-style-type: none;
}

.section-bonus .container .bonus-form form .buttons .hiddenbtn {
  font-size: 16px;
  font-family: "Circe", "PT Sans", sans-serif;
  font-weight: 400;
  padding: 6px 20px 4px;
  background-color: rgb(240, 240, 240);
  border: 1px solid rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
</style>
